import styled from '@emotion/styled';
import { GenericLazyString, gettext } from '@eventbrite/i18n';
import { Button, InlineAlert } from '@eventbrite/marmalade';
import React from 'react';

export enum AlertTestId {
    Container = 'AlertContainer',
}

export interface AlertProps {
    ctaText?: GenericLazyString | string;
    onCtaClick?: Function;
    closeTitle?: string;
    onClose?: () => void;
    icon?: JSX.Element;
    title: string;
    description: string | JSX.Element;
    variant: 'danger' | 'success' | 'warning' | 'info';
}

export const defaultAlertErrorMessage: AlertProps = {
    title: gettext('Something went wrong').toString(),
    description: gettext(
        'We ran into an issue processing your request. Please try again in a few minutes.',
    ).toString(),
    variant: 'danger',
};

export const Alert: React.FC<AlertProps> = ({
    ctaText,
    onCtaClick,
    closeTitle,
    onClose,
    icon,
    title,
    description,
    variant,
}) => {
    return (
        <AlertContainer>
            <InlineAlert
                icon={icon}
                description={description}
                title={title}
                variant={variant}
                closeOnClick={onClose}
                closeTitle={closeTitle}
                cta={
                    ctaText && onCtaClick ? (
                        <Button
                            variant="ghost"
                            onClick={() => onCtaClick()}
                            data-testid={AlertTestId.Container}
                        >
                            {ctaText}
                        </Button>
                    ) : undefined
                }
            />
        </AlertContainer>
    );
};

const AlertContainer = styled.div`
    padding: 8px;
`;
